/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ChangeEvent, FocusEvent } from 'react';
import type { TFunction } from 'i18next';
import U2000InputText from '../../../u2000Core/components/formControls/input/U2000InputText';
import U2000Label from '../../../u2000Core/components/formControls/label/U2000Label';
import { NS } from '../../U3206';
import { U2000FormStateEnumEditMode, U2000FormStateEnumState } from '../../../u2000Core/reducer/formReducer/U2000FormState';
import type { U2000FormStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import type { U3206AiUserGroupFormRow } from '../../U3206Service';

interface U3206AiUserGroupHeaderProps {
  formStateHandlers: U2000FormStateHandlers<U3206AiUserGroupFormRow>;
  t: TFunction;
}

function U3206AiUserGroupHeader({ formStateHandlers, t }: U3206AiUserGroupHeaderProps) {
  const data = formStateHandlers.getData();
  const readonly = formStateHandlers.getFormState() === U2000FormStateEnumState.READ;
  const isCreate = formStateHandlers.getFormEditMode() === U2000FormStateEnumEditMode.ADD;
  const errors = formStateHandlers.getErrors();
  const touched = formStateHandlers.getTouched();
  const submitted = formStateHandlers.isSubmitted();

  const activeChecked = data?.active === true;
  const errActive = errors.active;
  const hasActiveError = (touched.active && errActive !== undefined) || (submitted && errActive !== undefined);

  const setActiveFromCheckbox = (checked: boolean) => {
    const ev = { target: { id: 'active' } } as ChangeEvent<HTMLInputElement>;
    formStateHandlers.onChange?.(ev, checked);
  };

  const blurActive = () => {
    formStateHandlers.onBlur?.({ target: { id: 'active' } } as FocusEvent<HTMLInputElement>);
  };

  if (!data) return null;

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div className="flex min-w-0 flex-col gap-1.5">
        <U2000Label htmlFor="code" label={t('lblCode', { ns: NS })} required={isCreate} />
        <U2000InputText
          hideLabel
          formStateHandlers={formStateHandlers as any}
          fieldName="code"
          label={t('lblCode', { ns: NS })}
          required={isCreate}
          readonly={readonly || !isCreate}
        />
      </div>

      <div className="flex min-w-0 flex-col gap-1.5">
        <U2000Label htmlFor="name" label={t('lblName', { ns: NS })} required />
        <U2000InputText
          hideLabel
          formStateHandlers={formStateHandlers as any}
          fieldName="name"
          label={t('lblName', { ns: NS })}
          required
          readonly={readonly}
        />
      </div>

      <div className="md:col-span-2">
        <U2000InputText
          formStateHandlers={formStateHandlers as any}
          fieldName="description"
          label={t('lblDescription', { ns: NS })}
          readonly={readonly}
        />
      </div>

      <div className="flex min-w-0 flex-col gap-1.5">
        <U2000Label htmlFor="active" label={t('lblActive', { ns: NS })} required />
        <div className="flex items-center pt-1">
          <input
            id="active"
            type="checkbox"
            checked={activeChecked}
            disabled={readonly}
            onChange={(e) => setActiveFromCheckbox(e.target.checked)}
            onBlur={blurActive}
            className="h-4 w-4 rounded-sm border-gray-300"
            aria-invalid={hasActiveError}
          />
        </div>
      </div>
    </div>
  );
}

export default U3206AiUserGroupHeader;
